import { FC, useState } from 'react';
import { Button, Popover, Tag } from 'antd';
import { TbInfoCircle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import { AlertRequiredField, alertRequiredFieldDetails } from '../../requiredFields';
import { alertFormStepsByKey } from '../../steps';

interface AlertRequiredFieldsPreviewPopoverProps {
    fields: AlertRequiredField[];
    onSelect: (field: AlertRequiredField) => void;
}

const AlertRequiredFieldsPreviewPopover: FC<AlertRequiredFieldsPreviewPopoverProps> = ({ fields, onSelect }) => {
    const { token } = useAntDesignTheme();
    const [open, setOpen] = useState(false);

    const content = (
        <div style={{ width: 248 }}>
            <small style={{ color: token.colorTextTertiary, display: 'block', padding: '0.25rem 0.75rem' }}>
                Complete Before Creating
            </small>
            <div style={{ borderTop: `1px solid ${token.colorBorderSecondary}`, marginTop: '0.25rem' }}>
                {fields.map((field) => {
                    const details = alertRequiredFieldDetails[field];
                    const section = alertFormStepsByKey[details.sectionKey];

                    return (
                        <Button
                            key={field}
                            block
                            type='text'
                            style={{
                                borderBottom: `1px solid ${token.colorBorderSecondary}`,
                                borderRadius: 0,
                                height: 'auto',
                                justifyContent: 'flex-start',
                                minHeight: '3.5rem',
                                textAlign: 'left',
                            }}
                            onClick={() => {
                                onSelect(field);
                                setOpen(false);
                            }}
                        >
                            <span style={{ display: 'flex', flexDirection: 'column', gap: '0.125rem', minWidth: 0 }}>
                                <span>{details.label}</span>
                                <small style={{ color: token.colorTextTertiary, fontWeight: 400 }}>
                                    {section.label}
                                </small>
                            </span>
                        </Button>
                    );
                })}
            </div>
        </div>
    );

    return (
        <Popover
            arrow={false}
            content={content}
            open={open}
            placement='bottomRight'
            trigger='click'
            onOpenChange={setOpen}
        >
            <Tag bordered={false} color='gold' style={{ margin: 0 }}>
                <span
                    style={{
                        alignItems: 'center',
                        display: 'inline-flex',
                        gap: '0.25rem',
                        justifyContent: 'center',
                        verticalAlign: '-0.125rem',
                    }}
                >
                    <TbInfoCircle style={{ flex: '0 0 auto' }} />
                    <span>{fields.length} remaining</span>
                </span>
            </Tag>
        </Popover>
    );
};

export default AlertRequiredFieldsPreviewPopover;
